import { Box, Flex, Text } from "@chakra-ui/react";
import { useLimites } from "../../hooks/pdv/useLimites";

export function Limites(){

  const {data} = useLimites()
  const showDinheiro = data?.limiteDinheiro !== undefined;
  const showCartao = data?.limiteCartao !== undefined;

  if (!showDinheiro && !showCartao) {
    return null;
  }

  return (
    <Box>
      <Text textTransform={'uppercase'} fontSize={'sm'} fontWeight={'bold'} color={'#2222cc'}>Seus limites</Text>
      <Flex gap={2}>
        {showDinheiro && <Text fontSize={'lg'}>Dinheiro: {data?.limiteDinheiro}</Text>}
        {showDinheiro && showCartao && <Text fontSize={'lg'}>-</Text>}
        {showCartao && <Text fontSize={'lg'}>Cartão: {data?.limiteCartao}</Text>}
      </Flex>
    </Box>
  )
}
